import { render, staticRenderFns } from "./SelectColor.vue?vue&type=template&id=a3d01686"
import script from "./SelectColor.vue?vue&type=script&lang=js"
export * from "./SelectColor.vue?vue&type=script&lang=js"
import style0 from "./SelectColor.vue?vue&type=style&index=0&id=a3d01686&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports